import DashboardImg from '@assets/images/video-tutorial/dashboard.png'
import { VideoTutorial } from '@components/VideoTutorial'
import { useVideoTutorial } from '@components/VideoTutorial/useVideoTutorial'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import css from './styles.module.css'

export const DashboardTutorial: React.FC = () => {
  const { dashboardId, handleViewedTutorial } = useVideoTutorial()

  if (!dashboardId) {
    return null
  }

  const handleLinkClick = () => {
    handleViewedTutorial(dashboardId)
    sendGtmEvent(GtmTriggerName.DASHBOARD_INTRO)
  }

  const handleCloseClick = () => {
    handleViewedTutorial(dashboardId)
  }

  return (
    <div className={css.video_tutorial_wrap}>
      <VideoTutorial
        title="Welcome to Dashboard"
        description="Take a quick tour around the dashboard"
        img={DashboardImg}
        link="https://youtu.be/rMId6sQrYUo?si=p-jYFPItJ0Q27GfU"
        onLinkClick={handleLinkClick}
        onCloseClick={handleCloseClick}
      />
    </div>
  )
}
